@if (itemWithAnswerForm) {
  <ng-container [formGroup]="itemWithAnswerForm">
    <!-- Item -->
    <div class="col-12">
      <label class="form-label">{{ 'bookings.modal.item' | translate }}*</label>
      <select class="form-control form-select" name="item"
        [formControl]="itemToBook"
        (change)="fetchQuestionsForItem()">
        @for (item of availableItems; track item) {
          <option
          [ngValue]="item">{{ item['name' + crtLang.toUpperCase()] }}</option>
        }
      </select>
      <app-form-error [control]="itemToBook"></app-form-error>
    </div>
    @if (answersForm.enabled) {
      <div formArrayName="answers">
        <div class="row">
          @for (answerControl of answerControls; track answerControl; let i = $index) {
            <div class="col-12 col-sm-6">
              <label class="form-label">{{ questions[i]['question' + crtLang.toUpperCase()] }}*</label>
              @if (questions[i].answerType === ItemToBookAnswerType.Number) {
                <input
                  class="form-control"
                  [formControlName]="i"
                  placeholder="{{ questions[i]['question' + crtLang.toUpperCase()] }}"
                  pattern="{{ FormUtils.textInputPattern }}" type="number" step="1">
              } @else if (questions[i].answerType === ItemToBookAnswerType.Text) {
                <input
                  class="form-control"
                  [formControlName]="i"
                  placeholder="{{ questions[i]['question' + crtLang.toUpperCase()] }}"
                  pattern="{{ FormUtils.textInputPattern }}" type="text" maxlength="50">
              }
              <div>
                @if (questions[i].answerType === ItemToBookAnswerType.Boolean) {
                  <div class="btn-group" role="group">
                    <input class="btn-check" type="radio"
                      [formGroupName]="i"
                      [value]="'false'">
                      <label class="btn btn-toggle btn-toggle-left h-auto"
                        [ngClass]="{ active: answerControl.value === 'true' }"
                        translate="common.yes"
                        (click)="answerControl.setValue('true'); answerControl.markAsDirty()"
                        (keyup)="answerControl.setValue('true'); answerControl.markAsDirty()">
                      </label>
                      <input class="btn-check" type="radio"
                        [formGroupName]="i"
                        [value]="'true'">
                        <label class="btn btn-toggle btn-toggle-right h-auto"
                          [ngClass]="{ active: answerControl.value === 'false' }"
                          translate="common.no"
                          (click)="answerControl.setValue('false'); answerControl.markAsDirty()"
                          (keyup)="answerControl.setValue('false'); answerControl.markAsDirty()">
                        </label>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </ng-container>
    }
